module.exports = __webpack_public_path__ + "img/成都办公室1.f1b564c3.webp";